import React from 'react';
import { Link } from 'react-router-dom';
import { Presentation, ArrowSquareOut } from '@phosphor-icons/react';

export default function CanvasPreview({ preview }) {
  const isAvailable = Boolean(preview?.available);

  return (
    <div className="flex h-full flex-col justify-between rounded-xl border border-[var(--line)] bg-[var(--surface-card)] p-5 shadow-sm">
      <div>
        <div className="flex items-center justify-between border-b border-[var(--line)] pb-3">
          <div className="flex items-center gap-2">
            <Presentation size={18} className="text-slate-700" aria-hidden />
            <h3 className="font-heading text-sm font-bold text-slate-900">
              AI Canvas
            </h3>
          </div>
          <span className="rounded bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
            {isAvailable ? 'Active' : 'Unavailable'}
          </span>
        </div>

        <div className="py-4">
          <p className="text-xs text-slate-600 leading-relaxed">
            {isAvailable
              ? preview?.latestActivityExcerpt || 'Multi-agent collaboration canvas with live interactive workspace.'
              : 'Collaborative strategy canvas with multi-agent orchestration and human steward validation.'}
          </p>

          {!isAvailable && (
            <div className="mt-4 rounded-lg border border-dashed border-slate-200 bg-slate-50/50 p-3 text-center">
              <span className="text-[11px] font-medium text-slate-500">
                Collaboration Engine activates in Gate 10 / 11
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="border-t border-[var(--line)] pt-3">
        <Link
          to="/canvas"
          className="flex items-center justify-between text-xs font-semibold text-slate-900 hover:text-slate-700"
          aria-label="Open AI Canvas Surface"
        >
          <span>Open Canvas</span>
          <ArrowSquareOut size={14} />
        </Link>
      </div>
    </div>
  );
}
